// Options Actions
export const FETCH_PRACTICE_REQUEST = "FETCH_PRACTICE_REQUEST";
export const FETCH_PRACTICE_SUCCESS = "FETCH_PRACTICE_SUCCESS";
export const FETCH_PRACTICE_ERROR = "FETCH_PRACTICE_ERROR";